import { prop } from 'ramda';
import { urls } from '../../config.js';
import { translateHuggg } from '../../utils/huggg';

/**
 * Toggles a huggg's sent status
 *
 * huggg.toggleSent(axios, id).then( ... )
 * huggg.toggleSent(axios, id).then( ... )
 *
 * @param {Object} [axios=axios] Axios instance.
 * @param {String} id Huggg ID.
 * @throws {Error} If no huggg ID provided
 * @returns {Promise} Unresolved promise containing formatted data.
 */
var toggleSent = function toggleSent(axios, id) {
  if (!id) {
    throw new Error('Prop `id` is required in `huggg.toggleSent`');
  }
  return axios.post(urls.apiV2("/huggg/".concat(id, "/toggleSent"))).then(prop('data')).then(function (obj) {
    return translateHuggg(obj.data, obj.embedded);
  });
};
export default toggleSent;